/**
 * Pastille de navigation : ce qui attend dans une rubrique (messages non lus),
 * posée sur l'icône de la barre du bas, de la colonne latérale ou de l'onglet
 * Menu. Comme les applications de messagerie du marché (iOS, Material) : un
 * nombre en pastille rouge (« 99+ » au-delà), ou un simple point quand le
 * nombre est ailleurs (« Menu » : une rubrique qu'il contient attend). Le
 * nombre est lu en clair par les lecteurs d'écran (« 3 non lus »), jamais par
 * la seule couleur. Rien quand il n'y a rien.
 */
import type { ReactNode } from 'react';

/** Texte de la pastille : le nombre, plafonné à « 99+ ». */
export function navBadgeText(count: number): string {
  return count > 99 ? '99+' : String(count);
}

export function NavBadge(props: {
  /** Ce qui attend ; 0 ou absent : aucune pastille. */
  count?: number | undefined;
  /** Ce que compte la pastille, lu après le nombre (« non lus »). */
  label: string;
  /** Un point sans nombre : quelque chose attend, le détail est ailleurs. */
  dot?: boolean;
}): ReactNode {
  const count = props.count ?? 0;
  if (count <= 0) return null;
  return (
    <>
      <span className={props.dot ? 'ui-nav-badge ui-nav-badge--dot' : 'ui-nav-badge'} aria-hidden="true" data-ui="nav-badge">
        {props.dot ? null : navBadgeText(count)}
      </span>
      <span className="sr-only">{props.dot ? `, ${props.label}` : `, ${count} ${props.label}`}</span>
    </>
  );
}
